import firebaseService from 'utils/firebase/firebase';

// firebaseService.remoteConfig is the RNFirebase-shaped facade — its
// getValue(key) wraps the modular getValue(rcInstance, key) call internally.
const getRemoteConfigValue = (remoteConfigKey) => {
  const result = firebaseService.remoteConfig.getValue(remoteConfigKey);
  console.log(
    '[WEBGL_DBG] getRemoteConfigValue key=' +
      remoteConfigKey +
      ' source=' +
      (typeof result.getSource === 'function' ? result.getSource() : '(no getSource)'),
  );
  return result;
};

export default getRemoteConfigValue;
